import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import SentimentVeryDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentVeryDissatisfiedOutlined";
import SentimentNeutralOutlinedIcon from "@mui/icons-material/SentimentNeutralOutlined";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltOutlinedIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedOutlinedIcon from "@mui/icons-material/SentimentVerySatisfiedOutlined";

export const moods = [
  { icon: SentimentVerySatisfiedOutlinedIcon, description: "Happy" },
  { icon: SentimentSatisfiedAltOutlinedIcon, description: "Good" },
  { icon: SentimentSatisfiedIcon, description: "OK" },
  { icon: SentimentNeutralOutlinedIcon, description: "Neutral" },
  { icon: SentimentDissatisfiedOutlinedIcon, description: "Sad" },
  { icon: SentimentVeryDissatisfiedOutlinedIcon, description: "Awful" },
];

// Good
//   Accomplished
//   Grateful
//   Happy
//   Hopeful
//   Productive
//   Relaxed
// Average
//   Tense
//   Disconnected
//   Neutral
//   Tired
//   Unfocussed
//   Unmotivated
// Not Great
//   Angry
//   Sad
//   Sick
//   Stressed
//   Anxious
//   Exhausted
